


































































import Vue from "vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import moment from "moment";

import { formatDate } from "@/shared/scripts/helpers/date";

export default Vue.extend({
    name: "InputCalendar",
    components: {
        "VueCtkDateTimePicker": VueCtkDateTimePicker,
    },
    props: {
        inputLabel: {
            type: String,
            required: true
        },
        inputDescription: {
            type: String,
            required: false,
            default: "",
        },
        inputOptional: {
            type: Boolean,
            required: false,
            default: false
        },
        errorMessage: {
            type: String,
            required: false,
            default: null
        },
        id: {
            type: String,
            required: true
        },
        defaultValue: {
            type: String,
            required: false,
            default: ""
        },
        theme: {
            type: String,
            required: false,
            default: ""
        },
        // Format should be YYYY-MM-DD
        minDate: {
            type: String,
            required: false,
            default: ""
        },
        // Format should be YYYY-MM-DD
        maxDate: {
            type: String,
            required: false,
            default: ""
        },
        locale: {
            type: String,
            required: false,
            default: "fr"
        },
        formatedDateFormat: {
            type: String,
            required: false,
            default: "MM/DD/YYYY"
        }
    },
    data: function () {
        return {
            baseValue: this.defaultValue as string,
            datePickerValue: "" as string,
            inputValue: "" as string,
        };
    },
    computed: {
        baseValueFormated: function(): string {
            if (this.baseValue !== "") {
                return formatDate(moment(this.baseValue, "YYYY-MM-DD").format(), this.locale);
            }

            return this.baseValue;
        },
    },
    watch: {
        defaultValue: function (value) {
            this.setValues(value);
        },
        baseValue: function (value) {
            this.$emit("update-value", value);
        }

    },
    mounted: function () {
        this.inputValue = this.baseValueFormated;
        this.datePickerValue = this.baseValue;
    },
    methods: {
        setValues: function (value: string) {
            this.baseValue = value;
            this.datePickerValue = value;
            this.inputValue = this.baseValueFormated;
        },
        handleInputBlur: function (event: FocusEvent) {
            const target = event.target as HTMLInputElement;
            const value = target.value;

            // Validate the value base on min and max props
            const testInput = this.validateDate(value);

            if (testInput.valid) {
                // Format value has expected
                if (moment(value).isValid()) {
                    this.setValues(moment(value).format("YYYY-MM-DD"));
                }
            } else {
                // Input is invalid, replace it by the "closest valid value"
                if (testInput.closestValidValue) {
                    this.setValues(testInput.closestValidValue);
                }
            }
        },
        validateDate: function (date: string) {
            // Test if date is before the minimum allowed
            if (this.minDate.length > 0) {
                if (moment(date).isBefore(this.minDate)) {
                    return {
                        "valid": false,
                        "type": "minDate",
                        "closestValidValue": this.minDate
                    };
                }
            }

            // Test if date is after the maximum allowed
            if (this.minDate.length > 0) {
                if (moment(date).isAfter(this.maxDate)) {
                    return {
                        "valid": false,
                        "type": "maxDate",
                        "closestValidValue": this.maxDate
                    };
                }
            }

            // Date is valid
            return {
                "valid": true
            };
        }
    }
});
